// import config from 'config';

/* eslint-disable */
import { authHeader } from '../_helpers';
import { api } from '../_helpers/api';
import * as Cookies from 'js-cookie';

export const matchService = {
    getDataChart,
    logout,
    getAll,
    getDataRoleModel,
    getDataCandidate,
    getDataCandidateFilter,
    getDataDashboard,
    getColor
};

function getDataChart(params) {
    return api.fetchData('/match-scoring/data-chart', params)
        // .then(handleResponse)
        .then(response => {
            return response;
        });
};

function getDataCandidateFilter(params) {
    return api.fetchData('/users/list-candidate', params)
        // .then(handleResponse)
        .then(response => {
            return response;
        });
};

function getDataRoleModel(params) {
    return api.fetchData('/role-model/all', params)
        // .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getDataCandidate(params) {
    return api.fetchData('/match-scoring/all', params)
        // .then(handleResponse)
        .then(response => {
            return response;
        });
};


function getDataDashboard(params) {
    return api.fetchData('/dashboard/data-header', params)
        // .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getColor(params) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`https://redwhiteanalytics.com/api/tade/get-color/${params.code}`, requestOptions).then(handleResponse);
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`http://localhost:8080/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
